/**
 * Button wrapped in our custom style
 * Supports both button and link semantics for WCAG compliance
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import styles from './UnderlineButton.module.scss';
import { onClickPropValidator } from './UnderlineButton.utils';

const { container } = styles;

const UnderlineButton = ({
  children,
  buttonText,
  onClick,
  className,
  testId,
  to,
  href,
  ...rest
}) => {
  const classes = [container];
  if (className) {
    classes.push(className);
  }

  // If 'to' prop is provided, render as React Router Link for navigation
  if (to) {
    return (
      <Link
        to={to}
        className={classes.join(' ')}
        onClick={onClick}
        data-testid={testId}
        {...rest}
      >
        {children || buttonText}
      </Link>
    );
  }

  // If 'href' prop is provided, render as anchor tag for external links
  if (href) {
    return (
      <a
        href={href}
        className={classes.join(' ')}
        onClick={onClick}
        data-testid={testId}
        {...rest}
      >
        {children || buttonText}
      </a>
    );
  }

  // Default: render as button for actions
  return (
    <button
      type="button"
      className={classes.join(' ')}
      onClick={onClick}
      data-testid={testId}
      {...rest}
    >
      {children || buttonText}
    </button>
  );
};

UnderlineButton.propTypes = {
  children: PropTypes.node,
  buttonText: PropTypes.string,
  onClick: onClickPropValidator,
  className: PropTypes.string,
  testId: PropTypes.string,
  to: PropTypes.string,
  href: PropTypes.string
};

UnderlineButton.defaultProps = {
  children: null,
  buttonText: '',
  onClick: null,
  className: '',
  testId: '',
  to: null,
  href: null
};

export default UnderlineButton;
